import { Button, Textarea } from "@mantine/core";
import { useState } from "react";
import { Upload as IconUpload } from "@phosphor-icons/react";

interface ProspectImportProps {
  doImport: (content: string) => void;
  disabled?: boolean;
}

export default function ProspectImport({ doImport, disabled = false }: ProspectImportProps) {
  const [input, setInput] = useState("");

  const onSubmit = () => {
    doImport(input);
    setInput("");
  };

  return (
    <div>
      <Textarea
        label="Paste prospecting logs from event log"
        value={input}
        onChange={(e) => setInput(e.currentTarget.value)}
        minRows={8}
      />
      <Button
        mt="sm"
        leftSection={<IconUpload size={16} />}
        disabled={disabled || input.trim() === ""}
        onClick={onSubmit}
      >
        Import Log
      </Button>
    </div>
  );
}
